import useWorkspace from "./useWorkspace"
import useWorkspaceCapabilities from "./useWorkspaceCapabilities"

const useWorkspaceAccess = () => {
  const { workspace, isLoading: isLoadingWorkspace } = useWorkspace()
  const { capabilities, isLoading: isLoadingCapabilities } = useWorkspaceCapabilities()
  const permissions = capabilities?.capabilities

  return {
    role: capabilities?.role ?? workspace?.role_name ?? "",
    isQa: Boolean(capabilities?.is_qa ?? workspace?.is_qa),
    workspace,
    capabilities,
    permissions,
    isLoading: isLoadingWorkspace || isLoadingCapabilities,
    canCreateWorkspace: Boolean(permissions?.can_create_workspace),
    canUpdateWorkspaceDetails: Boolean(permissions?.workspace?.update_details),
    canDeleteWorkspace: Boolean(permissions?.workspace?.delete),
    canViewTeam: Boolean(permissions?.team?.view),
    canInviteTeam: Boolean(permissions?.team?.invite),
    canUpdateTeamRoles: Boolean(permissions?.team?.update_roles),
    canRemoveTeamMembers: Boolean(permissions?.team?.remove_members),
    canCancelTeamInvites: Boolean(permissions?.team?.cancel_invites),
    canManageDomains: Boolean(permissions?.domains?.manage),
    canVerifyDomains: Boolean(permissions?.domains?.verify),
    canManageIntegrations: Boolean(permissions?.integrations?.manage),
    canManageExperimentDefaults: Boolean(permissions?.settings?.manage_experiment_defaults),
    canManageProfitTracking: Boolean(permissions?.settings?.manage_profit_tracking),
    canViewBilling: Boolean(permissions?.billing?.go_to_billing_page),
    canViewBillingSummary: Boolean(permissions?.billing?.view_billing_summary),
    canEditPaymentMethods: Boolean(permissions?.billing?.edit_payment_methods),
    canManageBillingContacts: Boolean(permissions?.billing?.manage_billing_contacts),
    canViewInvoices: Boolean(permissions?.billing?.view_invoices),
    canChooseBillingPlan: Boolean(permissions?.billing?.choose_upgrade_downgrade_plan),
    canManageExtraCredits: Boolean(permissions?.billing?.enable_disable_extra_credits),
    canCancelDowngrades: Boolean(permissions?.billing?.cancel_downgrades),
  }
}

export default useWorkspaceAccess
